import Loading from "vue-loading-overlay";
import {authHeader} from "../../../auth";
import mixin from "../../../mixin";
export default {
    name: "TermsAndCondition",
    mixins: [mixin],
    components: {
        Loading
    },
    data() {
        return {
            isLoading: false,
            fullPage: true,
            loader: "bars",
            cartJsonString: localStorage.getItem('cart'),
            cartPurchaseJsonString: localStorage.getItem('purchase_cart'),
            totalcartData:{},
            getTermsURL: 'get-terms-condition',
            getPurchaseTermsURL: 'get-purchase-terms-condition',
            setCompleteInvoice: 'complete-invoice',
            acceptTermsNCondition: false,
            terms: '',
        }
    },
    created() {
        console.log('cartJsonString = ',this.cartJsonString);
        console.log('cartPurchaseJsonString = ',this.cartPurchaseJsonString);
        this.totalcartData = this.loadCartMixin(this.cartJsonString,this.cartPurchaseJsonString); 
        console.log('this.totalcartData = ',this.totalcartData);
        this.getTermsAndCondition();
    },
    methods:{
        getTermsAndCondition: function()
        {
            this.getTermsURL = 'get-purchase-terms-condition';
            this.isLoading = true;
            this.$axios.get(this.$api + 'api/' + this.getTermsURL).then(response => {
                this.terms = response.data.data;
                console.log('Terms: ', this.terms);
                this.isLoading = false;
            }).catch(e => {
                console.log(e);
                this.isLoading = false;
            });
        },
        backToSellBox: function()
        {
            if(!this.$route.params.backurl)
            {
                this.$router.push({name: 'Cart'});    
            }
            else
            {
                //this.$router.push({name: 'buyCartBox'});               
            }
        },
        checkoutComplete: function() {
            this.isLoading = true;
            //return false;
            let cart = JSON.parse(this.cartJsonString);
            let cartPurchase = JSON.parse(this.cartPurchaseJsonString);
            
            console.log(localStorage.getItem('_token'));
            let checkToken = localStorage.getItem('_token');
            if(checkToken==null)
            {
                this.isLoading = true;
                this.showMessage('error', 'opps! Login Required.', 'Please login to complete checkout.');
                //this.$router.push({name: 'Login', params: { returnCallBack: 'TermsAndCondition' }});
                this.$router.push({path: '/login/TermsAndCondition'});
                return false;
                
            }
            else if(this.checkAuthentication(checkToken)==false)
            {
                this.isLoading = true;
                console.log('Checking api token status');
                this.showMessage('error', 'opps! Login Required.', 'Please login to complete checkout.');
                //this.$router.push({name: 'Login', params: { returnCallBack: 'TermsAndCondition' }});
                this.$router.push({path: '/login/TermsAndCondition'});
                return false;
            }
            console.log('checkToken = ',checkToken);
            //return false;
            let config = {
                    method: "POST",
                    url: this.$api + 'api/' + this.setCompleteInvoice,
                    headers: authHeader(),
                    data:{cart:cart,cartPurchase:cartPurchase}
                };

            this.$axios(config).then(response => {
                this.isLoading = true;
                let checkoutStatus = response.data;

                let cart = JSON.parse(this.cartJsonString);
                let cartPurchase = JSON.parse(this.cartPurchaseJsonString);
                console.log('cart = ', cart);
                console.log('cartPurchase = ',cartPurchase);

                if(checkoutStatus.status == 1)
                {
                        this.isLoading = false;
                        let cart = JSON.parse(this.cartJsonString);
                        let cartPurchase = JSON.parse(this.cartPurchaseJsonString);
                        console.log('cart = ', cart);
                        console.log('cartPurchase = ',cartPurchase);
                        if(cart!=null)
                        {
                            localStorage.setItem('cart',null);
                            this.showMessage('success', 'Thank You.', 'Your sell is complete.');
                            this.$emit('updateMySellCart', 0);  
                            this.$router.push({name: 'sellDeviceComplete', params: { invoiceID: checkoutStatus.invoice_id }});
                        }

                        if(cartPurchase!=null)
                        {
                            localStorage.setItem('cartPurchase',null);
                            this.showMessage('success', 'Thank You.', 'Your purchase is completed successfully.');
                            this.$emit('updateMySellCart', 0);  
                            this.$router.push({name: 'sellDeviceComplete', params: { invoiceID: checkoutStatus.invoice_id }});
                        }

                        // localStorage.setItem('cart',null);
                        // this.showMessage('success', 'Thank You.', 'Your sell is complete.');
                        // this.$emit('updateMySellCart', 0);  
                        // this.$router.push({name: 'sellDeviceComplete', params: { invoiceID: checkoutStatus.invoice_id }});

                }
                else
                {
                    this.isLoading = false;
                    if(checkoutStatus.status != 0)
                    {   
                        this.showMessage('error', 'Empty Sell Box.', 'Please add new item on your sell box.');
                    }
                    else
                    {
                        this.showMessage('error', 'opps!!.', 'Something went wrong, Please try again.');
                    }
                }
                this.isLoading = false;
            }).catch(e => {
                console.log(e);
                this.showMessage('error', 'Empty Box.', 'Please add new item on your sell/purchase box.');
                this.isLoading = false;
                
            });  

            // this.$axios.post(this.$api + 'api/' + this.setCompleteInvoice, cart, authHeader()).then(response => {
            //     let checkoutStatus = response.data;
            //     if(checkoutStatus.status == 1)
            //     {
                    
            //             this.showMessage('success', 'Thank You.', 'Your sell is complete.');
            //             //this.$emit('updateMySellCart', 0);  
            //             //this.$router.push({name: 'sellDeviceComplete', params: { invoiceID: checkoutStatus.invoice_id }});
                    
            //     }
            //     else
            //     {
            //         if(checkoutStatus.status != 0)
            //         {   
            //             this.showMessage('error', 'Empty Sell Box.', 'Please add new item on your sell box.');
            //         }
            //         else
            //         {
            //             this.showMessage('error', 'opps!!.', 'Something went wrong, Please try again.');
            //         }
            //     }
            // }).catch(e => {
            //     console.log(e);
            // });
        },
        finishCheckout: function(){
            if(this.acceptTermsNCondition)
            {
                this.checkoutComplete();
            }
            else
            {
                this.showMessage('warning', 'Field Missing.', 'Please read the terms & condition carefully and then accept our terms.');
            }  
        }
    }
}